import React from 'react';

function splitSegment(segment, phrase) {
  if (segment.highlight || !phrase || !segment.text.includes(phrase)) {
    return [segment];
  }

  const parts = [];
  let remaining = segment.text;

  while (remaining.includes(phrase)) {
    const index = remaining.indexOf(phrase);
    if (index > 0) {
      parts.push({ text: remaining.slice(0, index), highlight: false });
    }
    parts.push({ text: phrase, highlight: true });
    remaining = remaining.slice(index + phrase.length);
  }

  if (remaining) {
    parts.push({ text: remaining, highlight: false });
  }

  return parts;
}

/**
 * Underlines notable phrases listed in `highlights` (longest match first).
 */
export function HighlightedText({ text, highlights = [] }) {
  if (!highlights.length) return text;

  const sorted = [...highlights].sort((a, b) => b.length - a.length);
  let segments = [{ text, highlight: false }];

  for (const phrase of sorted) {
    segments = segments.flatMap((segment) => splitSegment(segment, phrase));
  }

  return segments.map((segment, index) =>
    segment.highlight ? (
      <span key={index} className="testimony-highlight">
        {segment.text}
      </span>
    ) : (
      <React.Fragment key={index}>{segment.text}</React.Fragment>
    ),
  );
}
